import { makeStateKey } from "@angular/core";
import { HandledHttpResponse, PaginatedResult } from "@uzenith360/http-utils";
import Category from "./types/category.interface";
import CategoryGalleriesData from "./types/category-galleries-data.type";
import CategoryMediaInteface from "./types/category-media.inteface";

export default makeStateKey<HandledHttpResponse<{ pageData: Category | undefined, galleries: PaginatedResult<CategoryGalleriesData[]> | undefined, media: PaginatedResult<CategoryMediaInteface[]> | undefined }>>('category-data');